import React from "react";

import RequiredLabel from "../../../../components/RequiredLabel/RequiredLabel";
import translate from "../../../../services/Translate";
import { CATEGORIES, SUBCATEGORIES } from "../../LandingPageJobBlocks.function";
import JobBlockTagsEditor from "../JobBlockTagsEditor/JobBlockTagsEditor";
import { JobBlockFormFieldsProps } from "./JobBlockFormFields.d";

const JobBlockFormFields = ({
  title,
  setTitle,
  category,
  setCategory,
  link,
  setLink,
  question,
  setQuestion,
  resume,
  setResume,
  tags,
  setTags,
  language,
  showDeprecated,
  deprecated,
  setDeprecated,
  subCategory,
  setSubCategory,
}: JobBlockFormFieldsProps) => {
  return (
    <React.Fragment>
      <label>
        <RequiredLabel label={translate(language, "GLOBAL.TITLE")} />
        <input className="form-control" value={title} onChange={(event) => setTitle(event.target.value)} />
      </label>

      <label>
        <RequiredLabel label={translate(language, "PAGES.LANDING_PAGE_JOB_BLOCKS.FORM_FIELDS.CATEGORY")} />
        <select className="form-control" value={category} onChange={(event) => setCategory(event.target.value)}>
          <option value="">
            — {translate(language, "PAGES.LANDING_PAGE_JOB_BLOCKS.FORM_FIELDS.CATEGORY_PLACEHOLDER")} —
          </option>
          {CATEGORIES.map((cat) => (
            <option key={cat} value={cat}>
              {cat}
            </option>
          ))}
        </select>
      </label>

      <label>
        {translate(language, "PAGES.LANDING_PAGE_JOB_BLOCKS.FORM_FIELDS.SUBCATEGORY")}
        <select className="form-control" value={subCategory} onChange={(event) => setSubCategory(event.target.value)}>
          <option value="">
            — {translate(language, "PAGES.LANDING_PAGE_JOB_BLOCKS.FORM_FIELDS.SUBCATEGORY_PLACEHOLDER")} —
          </option>
          {SUBCATEGORIES.map((subCat) => (
            <option key={subCat} value={subCat}>
              {subCat}
            </option>
          ))}
        </select>
      </label>

      <label>
        <RequiredLabel label={translate(language, "GLOBAL.LINK")} />
        <input className="form-control" value={link} onChange={(event) => setLink(event.target.value)} />
      </label>

      <label>
        <RequiredLabel label={translate(language, "PAGES.LANDING_PAGE_JOB_BLOCKS.FORM_FIELDS.QUESTION")} />
        <input className="form-control" value={question} onChange={(event) => setQuestion(event.target.value)} />
      </label>

      <label>
        <RequiredLabel label={translate(language, "PAGES.LANDING_PAGE_JOB_BLOCKS.FORM_FIELDS.RESUME")} />
        <textarea className="form-control" value={resume} onChange={(event) => setResume(event.target.value)} />
      </label>

      {showDeprecated && setDeprecated && (
        <label className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            checked={deprecated}
            onChange={(event) => setDeprecated(event.target.checked)}
          />
          <span className="form-check-label">{translate(language, "GLOBAL.DEPRECATED")}</span>
        </label>
      )}

      <JobBlockTagsEditor value={tags} onChange={setTags} language={language} />
    </React.Fragment>
  );
};

export default JobBlockFormFields;
